import { useEffect, useState } from "react";
import { Crown } from "lucide-react";

const LINKS = [
  { label: "Method", href: "#method" },
  { label: "Engines", href: "#engines" },
  { label: "The Score", href: "#score" },
  { label: "Results", href: "#results" },
  { label: "AI Advisor", href: "#assistant" },
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="main-nav"
      className={`fixed top-0 left-0 right-0 z-50 border-b backdrop-blur-2xl transition-colors duration-500 ${
        scrolled ? "bg-black/70 border-white/10" : "bg-black/30 border-transparent"
      }`}
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 lg:px-10">
        <a href="#top" data-testid="nav-logo" className="flex items-center gap-3">
          <span className="flex h-9 w-9 items-center justify-center rounded-full border border-[#D4AF37]/50 bg-[#D4AF37]/10">
            <Crown className="h-4 w-4 text-[#D4AF37]" strokeWidth={1.5} />
          </span>
          <span className="leading-tight">
            <span className="block font-serif text-lg font-semibold tracking-wide">KINGDOM</span>
            <span className="block text-[10px] font-medium uppercase tracking-[0.28em] text-zinc-400">
              Partnership Blueprint
            </span>
          </span>
        </a>

        <nav className="hidden items-center gap-8 lg:flex">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className="text-xs font-medium uppercase tracking-[0.18em] text-zinc-400 transition-colors duration-300 hover:text-[#D4AF37]"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-4">
          <a
            href="/login"
            data-testid="nav-signin-link"
            className="hidden text-xs font-semibold uppercase tracking-[0.14em] text-zinc-400 transition-colors duration-300 hover:text-[#D4AF37] sm:block"
          >
            Sign In
          </a>
          <a
            href="#access"
            data-testid="nav-cta-button"
            className="rounded-full bg-[#D4AF37] px-5 py-2.5 text-xs font-bold uppercase tracking-[0.14em] text-black transition-transform duration-300 hover:scale-105 hover:brightness-110"
          >
            Early Access
          </a>
        </div>
      </div>
    </header>
  );
}
